import browserHistory from 'utils/browserHistory';
import { initialSearchTab } from 'utils/currentLanguage';

const tabsProductArray = [
  'about',
  'technical-resources',
  'oe-numbers',
  'linked-vehicles',
  'parts-list',
  'replaces',
  'replaced-by',
];

export const activeProductTab = (tabName) => {
  return tabsProductArray.includes(tabName) ? tabName : 'about';
};

export const getCurrentTab = () => {
  const hash = window.location.hash.replace('#', '');
  const defaultSearchTab = window.defaultSearchTab;

  return hash || defaultSearchTab || initialSearchTab;
};

export const changeRoute = (tab) => {
  const path = browserHistory.location.pathname.split('/');
  path[path.length - 1] = tab.length ? tab : 'about';

  browserHistory.replace(path.join('/') + browserHistory.location.search);
};

export const changeRouteHash = (tab) => {
  window.location.hash = tab;
};



// WEBPACK FOOTER //
// ./src/utils/tabsHelper/tabsHelper.js